import { z } from 'zod';
/**
 * Feedback submission request schema
 */
export const FeedbackRequestSchema = z.object({
    project_id: z.string().describe('Project ID'),
    feedback_type: z.enum(['bug report', 'feature request']).describe('Type of feedback'),
    feedback_message: z.string().min(1).describe('Feedback message content'),
});
/**
 * Feedback submission response schema
 */
export const FeedbackResponseSchema = z.object({
    success: z.boolean().describe('Whether the feedback submission was successful'),
    message: z.string().optional().describe('Optional success or error message'),
});
//# sourceMappingURL=feedback.js.map